require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var Handlebars = require('handlebars');
var GenericView = require('views/generic.view.ts');
var Template = require('text-loader!../templates/forgot_password.template.htm');
require('dhtmlxMessage');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: $("#body"),
    tagName: 'div',
    template: Handlebars.compile(Template),
    initialize: function () {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var self = this;

        this.$el.html(this.template());
    },
    events:{
        "submit #form": "forgot",
        "keyup #email": "forgotWithEnter"
    },
    forgot: function()
    {
        var self = this;
        var email = encodeURIComponent($("#email").val());

        if(this.isEmail("#email")) {
            $.ajaxDefaultQ({
                url: '/rest/auth/password/forgot?email=' + email,
                type: 'POST'
            }).done(function(response, status, xhr){
                if(status == "success")
                {
                    window.open('/','_self');
                }
            })
            .fail(function(response) {
                //console.info("Forgot Password response failed");
                dhtmlx.alert({
                    type: "alert",
                    text: i18n.t("account.sth_wrong")+".",
                    callback: function (result) {
                        $("#email").val('');
                    }
                });
            })
        }

        return false;
    },
    forgotWithEnter: function(event)
    {
        event.preventDefault();
        if(this.isEmail("#email")) {
            if (event.keyCode == 13) {
                if($("#email").val() != null) {
                    this.forgot();
                }
            }
        }
    }
});

module.exports = TheView;